import React from "react";
import { useReveal } from "../../hooks/use-reveal";
import { cn } from "../../lib/utils";

export const Reveal = ({ as: Tag = "div", delay = 0, className = "", children, ...props }) => {
  const { ref, visible } = useReveal();
  return (
    <Tag
      ref={ref}
      className={cn("reveal", visible && "reveal-visible", className)}
      style={{ transitionDelay: visible ? `${delay}ms` : "0ms" }}
      {...props}
    >
      {children}
    </Tag>
  );
};

export const RevealGroup = ({ className = "", stagger = 90, children }) => {
  const items = React.Children.toArray(children);
  return (
    <div className={className}>
      {items.map((child, i) => (
        <Reveal key={i} delay={i * stagger}>
          {child}
        </Reveal>
      ))}
    </div>
  );
};
